import React from "react";
import { useTenant } from "../context/TenantContext";

export default function QuoteCard({ compact = false }) {
  const tenant = useTenant();
  const url = tenant?.contact?.quote_url || "https://primegymturf.com/#cta";
  const lim = tenant?.size_limits || { max_length: 12, max_width: 2 };
  return (
    <div className="border border-pgt-green/40 bg-gradient-to-b from-pgt-green/10 to-transparent rounded-sm p-5" data-testid="quote-card">
      <div className="pgt-eyebrow mb-2">Custom Project</div>
      <h3 className="pgt-heading text-2xl text-white mb-2">Building Something Bigger?</h3>
      <p className="text-sm text-white/60 leading-relaxed mb-4">
        For larger tracks, full gym floors and bespoke commercial installations, our team will create a custom quotation.
        Our online designer currently supports tracks up to {lim.max_length}m × {lim.max_width}m.
      </p>
      <a href={url} target="_blank" rel="noreferrer" data-testid="request-quote-btn"
        className="inline-block bg-pgt-green text-black font-display font-bold uppercase tracking-wider text-sm px-5 py-3 rounded-sm hover:bg-pgt-greenHover transition-colors">
        Request a Custom Quote →
      </a>
    </div>
  );
}
